import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as AppState from '../../_state/app.state';
import { FiltroState as FiltroState } from './filtro.reducer';

// Extends the app state to include the filtro feature.
// This is required because filtro are lazy loaded.
// So the reference to filtro cannot be added to app.state.ts directly.
export interface State extends AppState.State {
    filtro: FiltroState;
}

// Selector functions
const filtroState = createFeatureSelector<FiltroState>('filtroBuscar');

export const getMaterias = createSelector(
    filtroState,
    state => state.materias
);

export const getMateriasMcp = createSelector(
    filtroState,
    state => state.materiasMcp
);

export const getSelectedMaterias = createSelector(
    filtroState,
    state => state.selectedMaterias
);

export const getSelectedMateria = createSelector(
    filtroState,
    state => state.selectedMateria
);

export const getCursos = createSelector(
    filtroState,
    state => state.cursos
);

export const getSelectedCursos = createSelector(
    filtroState,
    state => state.selectedIsNuevo ? [ -1, ...state.selectedCursos ] : state.selectedCursos
);

export const getSelectedCurso = createSelector(
    filtroState,
    state => state.selectedCurso
);

export const getSelectedCursosHijos = createSelector(
    filtroState,
    state => state.cursos
        .filter(e => state.selectedCursos.indexOf(e.id) > -1)
        .map(e => e.cursos)
        .reduce((accumulator, value) => accumulator.concat(value), [])
        .map(e => e.id)
);

export const getPeriodos = createSelector(
    filtroState,
    state => state.periodos
);

export const getSelectedPeriodos = createSelector(
    filtroState,
    state => state.selectedPeriodos
);

export const getSelectedPeriodo = createSelector(
    filtroState,
    state => state.selectedPeriodo
);

export const getSelectedPeriodoOrDefault = createSelector(
    filtroState,
    state => state.selectedPeriodo > 0
        ? state.periodos.find(e => e.id === state.selectedPeriodo)
        : state.periodos[0] ?? { id: 0, nombre: '' }
);

export const getSelectedNombre = createSelector(
    filtroState,
    state => state.selectedNombre ?? ''
);

export const getLoading = createSelector(
    filtroState,
    state => state.loading
);

export const getError = createSelector(
    filtroState,
    state => state.error
);

export const getSesiones = createSelector(
    filtroState,
    state => state.sesiones
);

export const getSelectedSesiones = createSelector(
    filtroState,
    state => state.selectedSesiones
);

export const getSelectedIsNuevo = createSelector(
    filtroState,
    state => state.selectedIsNuevo
);
